<template>
  <footer class="site-footer">
    <div class="container footer-top">
      <div class="brand-block">
        <div class="brand-title">
          <img class="mark" src="@/assets/logo.png" />
          <strong>中鸿云智</strong>
        </div>
        <p>中鸿云智（浙江）科技有限公司专注智慧场域管理与数字化政务服务。</p>
        <!-- <div class="socials">
          <a href="javascript:void(0)" aria-label="微信">微</a>
          <a href="javascript:void(0)" aria-label="微博">博</a>
          <a href="javascript:void(0)" aria-label="领英">in</a>
        </div> -->
      </div>

      <div class="footer-col">
        <h4>核心产品</h4>
        <p>小门神指挥中枢</p>
        <p>政务软件定制开发</p>
        <p>数企通解决方案</p>
        <p>数字化广告营销</p>
        <p>新能源充电站建设</p>
      </div>

      <div class="footer-col">
        <h4>公司信息</h4>
        <button type="button" :class="{ active: activeTab === 'about' }" @click="$emit('change-tab', 'about')">关于我们</button>
        <p>企业文化</p>
        <button type="button" :class="{ active: activeTab === 'join' }" @click="$emit('change-tab', 'join')">加入我们</button>
        <p>荣誉资质</p>
        <button type="button" :class="{ active: activeTab === 'contact' }" @click="$emit('change-tab', 'contact')">联系我们</button>
      </div>

      <div class="footer-col">
        <h4>联系我们</h4>
        <p>📍 浙江省杭州市拱墅区蓝天商务中心1202室</p>
        <p>📞 0571-28113599</p>
        <p>✉ 1637227159@qq.com</p>
      </div>
    </div>

    <div class="container copyright">
      <span>© 2026 中鸿云智（浙江）科技有限公司. 保留所有权利.</span>
      <div class="legal-links">
        <!-- <a href="javascript:void(0)">法律声明</a> -->
        <button type="button" @click="$emit('change-tab', 'privacy')">隐私政策</button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    activeTab: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="less">
@primary: #2463eb;

.site-footer {
  background: #07163a;
  color: #8d9eb7;
  margin-top: 64px;
}

.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.footer-top {
  padding-top: 30px ;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1.2fr;
  gap: 52px;
}

.brand-title {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  margin-bottom: 22px;
}

.brand-title strong {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}

.mark {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  background: #ffffff;
}

.brand-block p {
  margin: 0;
  line-height: 1.65;
  font-size: 16px;
  max-width: 550px;
  color: #a7bfdf;
}

.socials {
  margin-top: 34px;
  display: flex;
  gap: 14px;
}

.socials a {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #1a2a4e;
  color: #d8e6ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 13px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.socials a:hover {
  background: #2a6deb;
  transform: translateY(-2px);
}

.footer-col h4 {
  color: #fff;
  margin: 4px 0 24px;
  font-size: 20px;
}

.footer-col button,
.footer-col p {
  margin: 0 0 14px;
  color: #a7bfdf;
  line-height: 1.55;
  font-size: 16px;
}

.footer-col button {
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  transition: color 0.2s ease;
}

.footer-col button:hover,
.footer-col button.active {
  color: #fff;
}

.copyright {
  border-top: 1px solid #223153;
  min-height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 14px;
  color: #a2b8d8;
}

.legal-links {
  display: flex;
  align-items: center;
  gap: 36px;
}

.legal-links button {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  color: #d6e3fb;
  text-decoration: none;
  transition: color 0.2s ease;
}

.legal-links button:hover {
  color: #fff;
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .footer-top {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
  }

  .brand-title strong {
    font-size: 20px;
  }

  .brand-block p,
  .footer-col h4,
  .footer-col button,
  .footer-col p,
  .copyright {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .site-footer {
    margin-top: 48px;
  }

  .footer-top {
    padding: 44px 0 28px;
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .copyright {
    min-height: 56px;
    padding: 12px 0;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    font-size: 13px;
  }

  .legal-links {
    gap: 14px;
  }

  .brand-title strong {
    font-size: 14px;
  }

  .brand-block p,
  .footer-col h4,
  .footer-col button,
  .footer-col p {
    font-size: 14px;
  }
}
</style>
